export const ACTION_TAB_ORDER = 1
export const UNDERSTANDING_TAB_ORDER = 0
export const ENTRY_ID = '2AW1J9qsaozVZS7kJAFVKx'
export const SUPPORT_LS_KEY = 'supportTabHistory'
